import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { useTranslation } from '../data/translations';

export const Footer = () => {
  const { language } = useLanguage();
  const t = useTranslation(language);
  return (
    <footer className="bg-[#0A1628] text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
          <div>
            <div className="mb-6"><img src="https://customer-assets.emergentagent.com/job_a13cc131-3351-41ce-87d0-56be3a0fcef6/artifacts/sac0lcc8_Logo.png" alt="Beni Gipsergeschäft GmbH" className="h-16 w-auto" /></div>
            <p className="text-gray-400 text-sm leading-relaxed">{t.footer.description}</p>
            <p className="text-gray-500 text-xs mt-4">Unternehmen seit 2019</p>
          </div>
          <div>
            <h4 className="font-heading text-lg font-semibold mb-6">{t.footer.quickLinks}</h4>
            <ul className="space-y-3">
              {[{ path: '/', label: t.nav.home },{ path: '/dienstleistungen', label: t.nav.services },{ path: '/referenzen', label: t.nav.references },{ path: '/team', label: t.nav.team },{ path: '/kontakt', label: t.nav.contact }].map((link) => (
                <li key={link.path}><Link to={link.path} className="text-gray-400 hover:text-[#FF6B6B] transition-colors text-sm">{link.label}</Link></li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-heading text-lg font-semibold mb-6">{t.locations.hauptsitz.label}</h4>
            <ul className="space-y-3 text-sm text-gray-400">
              <li className="flex items-start space-x-3"><MapPin className="w-4 h-4 text-[#FF6B6B] mt-1 flex-shrink-0" /><span>{t.locations.hauptsitz.address}, {t.locations.hauptsitz.city}</span></li>
              <li><a href="tel:+41793591862" className="flex items-center space-x-3 hover:text-white transition-colors"><Phone className="w-4 h-4 text-[#00A651]" /><span>{t.locations.hauptsitz.phone}</span></a></li>
              <li><a href="mailto:beni-gipser@bluewin.ch" className="flex items-center space-x-3 hover:text-white transition-colors"><Mail className="w-4 h-4 text-[#FF6B6B]" /><span className="break-all">{t.locations.hauptsitz.email}</span></a></li>
            </ul>
            <div className="mt-6 text-sm text-gray-500">
              <p className="font-semibold text-gray-400 mb-1">{language === 'de' ? 'Einzugsgebiet' : 'Service Area'}</p>
              <p>Aesch, Basel, Reinach, Münchenstein, Muttenz, Laufen, Binningen, Oberwil, Therwil, Allschwil</p>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-700/50 py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-gray-500 text-sm">&copy; {new Date().getFullYear()} Beni Gipsergeschäft GmbH. {t.footer.rights}</p>
          <div className="flex items-center space-x-6">
            <Link to="/impressum" className="text-gray-500 hover:text-white text-sm transition-colors">{t.footer.impressum}</Link>
            <Link to="/agb" className="text-gray-500 hover:text-white text-sm transition-colors">AGB & Datenschutz</Link>
            <a href="https://www.alpenpro.agency" target="_blank" rel="noopener noreferrer" className="group inline-flex items-center space-x-2 text-gray-400 hover:text-white text-sm transition-all duration-300">
              <span className="font-medium">Made by</span>
              <span className="font-bold text-[#E31C23] group-hover:text-white transition-colors">Alpen Pro Agency</span>
              <svg className="w-4 h-4 opacity-0 group-hover:opacity-100 group-hover:translate-x-1 transition-all duration-300" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" /></svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
